import { Component, inject, input, InputSignal } from '@angular/core';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import { EEntityType, ERelationType } from '@web/dtos';
import { ITicketTileStyling } from '../ticket-tile/ticket-tile.component';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';

@Component({
  selector: 'aw-shopping-cart-headline',
  imports: [FilterTextsPipe, LanguagePipe],
  templateUrl: './shopping-cart-headline.component.html',
})
export class ShoppingCartHeadline {
  public readonly relationType: InputSignal<ERelationType> = input.required();

  protected readonly textStore: WebTextStore = inject(WebTextStore);
  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );

  protected readonly ERelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;

  getBackgroundColor(): string {
    if (this.corporateDesignService.isDarkModeActive()) {
      return this.corporateDesignService.corporateDesign().colorAdmixtures
        .dark_surface_01;
    }
    return this.corporateDesignService.corporateDesign().colorAdmixtures
      .standard_background;
  }

  public ticketStyle: ITicketTileStyling = {
    frame: {
      borderWidth: '1px',
      borderColor: this.corporateDesignService.isDarkModeActive()
        ? this.corporateDesignService.corporateDesign().colorAdmixtures
            .standard_background
        : this.corporateDesignService.corporateDesign().primaryBorderColor,
      backgroundColor: this.corporateDesignService.isDarkModeActive()
        ? this.corporateDesignService.corporateDesign().colorAdmixtures
            .dark_surface_01
        : this.corporateDesignService.corporateDesign().colorAdmixtures
            .standard_background,
    },
    list: {
      iconColor: '',
    },
  };
}
